import { Link } from "react-router-dom";

const LINE = "#7C3AED";

function Station({ to, label, sub, current, kind, testId, done }) {
  const ring = kind === "subject" ? "h-7 w-7 border-[5px]" : kind === "end" ? "h-5 w-5 border-[3px] border-dashed" : "h-6 w-6 border-4";
  return (
    <Link to={to} data-testid={testId} aria-current={current ? "page" : undefined}
      className="group relative z-10 flex min-w-0 flex-1 items-center gap-3 md:flex-col md:items-center md:gap-2 md:text-center focus:outline-none">
      <span className={`relative shrink-0 rounded-full bg-white ${ring} transition-transform duration-200 group-hover:scale-110 group-focus-visible:ring-2 group-focus-visible:ring-offset-2`}
        style={{ borderColor: kind === "end" ? "#A8A29E" : LINE }}>
        {current && <span className="absolute -inset-2 animate-ping rounded-full bg-violet-400/40" aria-hidden="true" />}
        {done && <span className="absolute inset-1 rounded-full bg-emerald-600" aria-hidden="true" />}
      </span>
      <span className="min-w-0">
        <span className={`block text-sm leading-tight ${current ? "font-semibold text-stone-900" : "text-stone-700 group-hover:text-stone-900"}`}>{label}</span>
        {sub && <span className="block font-mono text-[10px] uppercase tracking-wider text-stone-500">{sub}</span>}
      </span>
    </Link>
  );
}

// Subject → Course metro: the Pick-stage subject terminus feeds four course stations, which merge into Shortlist and Apply.
export function SciMetroLine({ subjectSlug, courses, current, shortlisted = [] }) {
  return (
    <nav aria-label="Subject to course line" data-testid="sci-metro-line" className="relative rounded-2xl border border-stone-200 bg-white px-5 py-6 md:px-8">
      <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500">Pick line · subject → course → shortlist</p>
      <div className="relative flex flex-col gap-5 md:flex-row md:gap-2">
        <span aria-hidden="true" className="absolute left-[13px] top-3 bottom-3 w-1.5 rounded md:left-6 md:right-6 md:top-[12px] md:bottom-auto md:h-1.5 md:w-auto" style={{ background: LINE }} />
        <Station to={`/preview/sci/subjects/${subjectSlug}`} label="Philosophy" sub="Subject" kind="subject"
          current={current === "subject"} testId="sci-metro-station-subject" />
        {courses.map((c) => (
          <Station key={c.degree_id} to={`/preview/sci/courses/${c.degree_id}`} label={c.label} sub={c.sub}
            current={current === c.degree_id} done={shortlisted.includes(c.degree_id)} testId={`sci-metro-station-${c.degree_id}`} />
        ))}
        <Station to="/shortlist" label="Shortlist" sub="Your list" kind="end" testId="sci-metro-station-shortlist" />
        <Station to="/applications" label="Apply" sub="Applications" kind="end" testId="sci-metro-station-apply" />
      </div>
    </nav>
  );
}
